<footer class="web-footer">
  <div class="web-footer__top">
    <div class="web-footer__top-content">
      <div class="web-footer__top-content-left">
        <a href="/">
          <fr8bot-web-logo />
        </a>
      </div>

      <div class="web-footer__top-content-center">
        <!--        <span class="web-footer-contact-info">-->
        <!--          Address:-->
        <!--          <a class="web-footer-contact-info__link">-->
        <!--            131 Continental Dr Ste 301, Newark, Delaware-->
        <!--          </a>-->
        <!--        </span>-->

        <span class="web-footer-contact-info">
          {{ 'landing.footer.phone' | translate }}:
          <a class="web-footer-contact-info__link" [href]="'tel:' + contacts.phoneE164">
            {{ contacts.phone }}
          </a>
        </span>

        <span class="web-footer-contact-info">
          {{ 'landing.footer.email' | translate }}:
          <a class="web-footer-contact-info__link" [href]="'mailto:' + contacts.email">
            {{ contacts.email }}
          </a>
        </span>
      </div>

      <div class="web-footer__top-content-right">
        <!--        <a class="web-footer-social">-->
        <!--          <fr8bot-ui-icon name="web-facebook" [size]="32" />-->
        <!--        </a>-->

        <!--        <a class="web-footer-social">-->
        <!--          <fr8bot-ui-icon name="web-instagram" [size]="32" />-->
        <!--        </a>-->

        <!--        <a class="web-footer-social">-->
        <!--          <fr8bot-ui-icon name="web-linkedin" [size]="32" />-->
        <!--        </a>-->

        <!--        <a class="web-footer-social">-->
        <!--          <fr8bot-ui-icon name="web-youtube" [size]="32" />-->
        <!--        </a>-->
      </div>
    </div>
  </div>

  <div class="web-footer__bottom">
    <div class="web-footer__bottom-content">
      <div class="web-footer__bottom-content-left">
        <span class="web-footer__bottom-content-left-copyright">
          {{ 'landing.footer.copyright' | translate }}
        </span>
        <!-- FR8BOT-1254: legal copy for a USPTO trademark filing; keep it verbatim and outside i18n. -->
        <span class="web-footer__bottom-content-left-services">
          FR8BOT — contract negotiation, transportation reservation, routing, traffic information,
          and transportation advisory services.
        </span>
      </div>

      <div class="web-footer__bottom-content-right">
        <a
          class="web-footer-document-link"
          data-testid="landing-footer-privacy"
          [href]="privacyPolicyUrl"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.footer.privacyPolicy' | translate }}
        </a>
        <!--        <a class="web-footer-document-link">Terms and conditions</a>-->
        <!--        <a class="web-footer-document-link">Policies and procedures</a>-->
      </div>
    </div>
  </div>
</footer>
